// extracted by mini-css-extract-plugin
export default {"item":"SingleSelectSubtreeView__item--qzP3p6I9z3JkJTcK6_zG"};